import { Pipe , PipeTransform } from '@angular/core';

@Pipe({
    standalone: false,
    name: 'getActiveSettingLabel'
}) 
export class GetActiveSettingLabelPipe implements PipeTransform {
    transform(children: any[]): string {
        if (!children || children?.length === 0) {
            return '';
        }
        const enabledSetting = children?.find(child => child.status === true);
        return enabledSetting?.label;
    }
}